import { gql } from '@apollo/client';
import { DictionaryBasicEventFragment } from './fragments';

export const GET_DICTIONARY_BASIC_EVENTS = gql`
  query GetDictionaryBasicEvents($schemaId: ID!, $term: String) {
    dictionaryBasicEvents(schemaId: $schemaId, term: $term) {
      values {
        ...DictionaryBasicEventFields
      }
    }
  }
  ${DictionaryBasicEventFragment}
`;
